import React from "react";
//styles
import styled from "styled-components";
//images
import athlete from "../img/athlete-small.png";
import theracer from "../img/theracer-small.png";
import goodtimes from "../img/goodtimes-small.png";
//Router
import { Link } from "react-router-dom";
//Animation
import { motion } from "framer-motion";
import {
  slider,
  linAnim,
  pageAnimation,
  fade,
  photoAnim,
  scrollReveal,
} from "../Animation";
import { useScroll } from "../components/useScroll";
import ScrollTop from "../components/ScrollTop";
const OurWork = () => {
  const [element, controls] = useScroll();
  const [element2, controls2] = useScroll();

  return (
    <Work
      style={{ background: "#fff" }}
      variants={pageAnimation}
      exit="exit"
      initial="hidden"
      animate="show"
    >
      <Frame1 variants={slider}></Frame1>
      <Frame2 variants={slider}></Frame2>
      <Frame3 variants={slider}></Frame3>
      <Frame4 variants={slider}></Frame4>
      <Movie>
        <motion.h2 variants={fade}>The Athlete</motion.h2>
        <motion.div variants={linAnim} className="line"></motion.div>
        <Link to="/work/the-athlete">
          <ImageContainer>
            <motion.img variants={photoAnim} src={athlete} alt="athlete" />
          </ImageContainer>
        </Link>
      </Movie>
      <Movie
        variants={scrollReveal}
        ref={element}
        animate={controls}
        initial="hidden"
      >
        <h2>The Racer</h2>
        <motion.div variants={linAnim} className="line"></motion.div>
        <Link to="/work/the-racer">
          <img src={theracer} alt="racer" />
        </Link>
      </Movie>
      <Movie
        variants={scrollReveal}
        ref={element2}
        animate={controls2}
        initial="hidden"
      >
        <h2>Good Times</h2>
        <motion.div variants={linAnim} className="line"></motion.div>
        <Link to="/work/good-times">
          <img src={goodtimes} alt="good times" />
        </Link>
      </Movie>
      <ScrollTop />
    </Work>
  );
};
const Work = styled(motion.div)`
  min-height: 100vh;
  overflow: hidden;
  padding: 5rem 10rem;
  h2 {
    padding: 0rem 2rem;
  }
  @media (max-width: 1300px) {
    padding: 2rem;
  }
`;
const Movie = styled(motion.div)`
  padding-bottom: 10rem;

  .line {
    height: 0.5rem;
    background: #23d997;
    margin: 2rem 3rem 3rem 0;
  }
  img {
    width: 100%;
    height: 90vh;
    object-fit: cover;
  }
  h2 {
    margin-left: -2rem;
  }
`;
const ImageContainer = styled.div`
  overflow: hidden;
`;
export default OurWork;
//Framer Motion
const Frame1 = styled(motion.div)`
  position: fixed;
  top: 10%;
  left: 0;
  width: 100%;
  height: 100vh;
  background: #fffebf;
  z-index: 3;
`;
const Frame2 = styled(Frame1)`
  background: #ff8efb;
`;
const Frame3 = styled(Frame1)`
  background: #8ed2ff;
`;
const Frame4 = styled(Frame1)`
  background: #8effa0;
`;
